import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appDropFile]',
    standalone: false
})
export class DropFileDirective {
  @Output() onFileDropped = new EventEmitter<any>();

  @HostBinding('class.file-over') fileOver: boolean;

  public constructor() { }

  @HostListener('dragover', ['$event']) public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event']) public onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver = false;
    this.onFileDropped.emit(event.dataTransfer.files[0]);
  }

}
